export default "__VITE_PUBLIC_ASSET__177c952b__"